import { ButtonProps } from '@mui/material';
import styled from 'styled-components';
import { Button } from '../StyledComponents';
import editSelectionIcon from '../../assets/icons/icon-edit-selection.svg';

const StyledEditSelectionButton = styled(Button)`
  && {
    border: none !important;
    border-radius: 8px;
    color: #2563EB;
    background: #F8F9FA !important;
    text-transform: none;
    min-width: auto;
    height: 36px;
    padding: 6px 12px;
    gap: 9px;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0;
    box-shadow: none !important;
    transition: none !important;

    &:hover {
      border: none !important;
      background: #F1F5F9 !important;
      box-shadow: 0px 1px 2px rgba(17, 24, 39, 0.08) !important;
    }
  }
`;

const Icon = styled.img`
  width: 14px;
  min-width: 14px;
  height: 14px;
  margin: 0;
  object-fit: contain;
`;

type EditSelectionButtonProps = Omit<ButtonProps, 'startIcon' | 'endIcon'> & {
  label?: string;
};

const EditSelectionButton = ({label = 'Edit Selection', ...props}: EditSelectionButtonProps) => {
  return (
    <StyledEditSelectionButton variant="outlined" color="primary" {...props}>
      <Icon src={editSelectionIcon} alt="" />
      {label}
    </StyledEditSelectionButton>
  );
};

export default EditSelectionButton;
